import Vue from 'vue';
import VueRouter from "vue-router";
Vue.use(VueRouter);

//路由配置
import Index from "../components/Index.vue";
import ContIndex from "../components/ContIndex.vue";
import ModuleDetail from "../components/ModuleDetail.vue";
import ProductDetail from "../components/ProductDetail.vue";
import ModuleList from "../components/ModuleList";
import VDLIndex from "../components/VDLIndex";
import AboutHQ from "../components/AboutHQ";
import JoinHQ from "../components/JoinHQ";
import ContactUs from "../components/ContactUs";
// import NewsHQ from "../components/NewsHQ";
import NewsCont from "../components/NewsCont";

const routes = [
    { path: '*',  redirect: '/index' },
    { path: '/index', component: Index },
    { path: '/contIndex/:type', name:"contIndex", component: ContIndex },
    { path: '/moduleDetail/:type', name:"ModuleDetail",  component: ModuleDetail },
    { path: '/proCont/:type/:id', name:"proCont",  component: ProductDetail },
    { path: '/moduleList/:type', name:"moduleList",  component: ModuleList },
    { path: '/vdlIndex/:type/:text', name:"vdlIndex",  component: VDLIndex },
    { path: '/aboutHQ', name:"aboutHQ",  component: AboutHQ },
    { path: '/joinHQ', name:"JoinHQ",  component: JoinHQ },
    { path: '/contactUs', name:"ContactUs",  component: ContactUs },
    // { path: '/newsHQ', name:"NewsHQ",  component: NewsHQ },
    { path: '/newsCont/:type/:bt', name:"NewsCont",  component: NewsCont },
]

const router = new VueRouter({
    // mode: 'history',
    routes // (缩写) 相当于 routes: routes
})

export default router;
